<template>
  <div class="ic-form__company">
    <h3>Dane do faktury</h3>

    <div class="row">
      <div class="col-md-8">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="company"
          name="company.company"
          :aria="$t('aria_required')"
          :label="$t('label_company_name')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcInput id="company" autocomplete="organization" v-model="data.company" @input="emitInput(data,validator)"></IcInput>
          </template>
        </IcFormRowWrapper>
      </div>
      <div class="col-md-4 form-padding-left">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="vatid"
          name="company.vatid"
          :aria="$t('aria_required')"
          :label="$t('label_vatid')"
          :labelWidth="4"
          :controlWidth="3"
        >
          <template slot-scope="{validator}">
            <IcInputVatId id="vatid" v-model="data.vatid" @input="emitInput(data,validator)"></IcInputVatId>
          </template>
        </IcFormRowWrapper>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="street"
          name="company.street"
          :aria="$t('aria_required')"
          :label="$t('label_street')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcInput id="street" v-model="data.street" @input="emitInput(data,validator)"></IcInput>
          </template>
        </IcFormRowWrapper>
      </div>
      <div class="col-md-2 form-padding-left">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="streetNo"
          name="company.streetNo"
          :aria="$t('aria_required')"
          :label="$t('label_streetNo')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcInput id="streetNo" v-model="data.streetNo" @input="emitInput(data,validator)"></IcInput>
          </template>
        </IcFormRowWrapper>
      </div>
      <div class="col-md-2 form-padding-left">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="apartment"
          name="address.apartment"
          :aria="$t('aria_required')"
          :label="$t('label_apartment')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcInput id="apartment" v-model="data.apartment" @input="$emit('input', data);"></IcInput>
          </template>
        </IcFormRowWrapper>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="zip"
          name="company.zip"
          :aria="$t('aria_required')"
          :label="$t('label_zip')"
          :labelWidth="4"
          :controlWidth="2"
        >
          <template slot-scope="{validator}">
            <IcInputZip id="zip" v-model="data.zip" @input="emitInput(data,validator)"></IcInputZip>
          </template>
        </IcFormRowWrapper>
      </div>
      <div class="col-md-9 form-padding-left">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="city"
          name="company.city"
          :aria="$t('aria_required')"
          :label="$t('label_city')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcInput id="city" v-model="data.city" @input="emitInput(data,validator)"></IcInput>
          </template>
        </IcFormRowWrapper>
      </div>
    </div>

    <IcFormRowWrapper id="einvoice" name="company.einvoice" :labelWidth="0" :controlWidth="12">
      <template slot-scope="{validator}">
        <IcCheckbox id="einvoice" v-model="data.einvoice" :val="1">{{$t('label_einvoice')}}</IcCheckbox>
      </template>
    </IcFormRowWrapper>
  </div>
</template>

<script>
import IcFormRowHorizontal from "@/components/ic-common/form/helpers/FormRowHorizontal";
import IcInput from "@/components/ic-common/form/controls/Input";
import IcInputVatId from "@/components/ic-common/form/controls/InputVatId";
import IcInputZip from "@/components/ic-common/form/controls/InputZip";
import IcCheckbox from "@/components/ic-common/form/controls/Checkbox";
import { Company } from "@/components/ic/form/contact/Model/Company";
import { emitInput } from "./mixins";

export default {
  name: "IcFormContactCompany",
  props: {
    value: {
      type: [Object],
      default: new Company()
    }
  },
  watch: {
    // data: {
    //   deep: true,
    //   handler: function(newValue, oldValue) {
    //     this.$emit("input", this.data);
    //   }
    // },
    value: function(newValue, oldValue) {
      this.data = this.value;
    }
  },
  data() {
    return {
      data: Object.assign({}, new Company(), this.value)
    };
  },
  methods: {
    emitInput
  },
  components: {
    IcFormRowHorizontal,
    IcInput,
    IcInputVatId,
    IcInputZip,
    IcCheckbox
  }
};
</script>

<style>
</style>
